'use strict';
var $ = require('jquery');

/**
 * @description Animations for the distribution modules
 */

function distributionmodules() {
    var is1774 = $('.landing-1774').length > 0;
    // Run on load
    $(window).on('load resize', function () {
        if (!is1774) {
            // Interaction on mouse hover and leave
            $('.dist-module-item')
                .mouseenter(function () {
                    $(this).find('.dist-module-image-img').addClass('dist-module-image-img-hover');
                    $(this).find('.dist-module-content').stop().animate({marginTop: '-32px'}, 500);
                    $(this).stop().animate({'padding-bottom': '32px'}, 500);
                })
                .mouseleave(function () {
                    $(this).find('.dist-module-image-img').removeClass('dist-module-image-img-hover');
                    $(this).find('.dist-module-content').stop().animate({marginTop: '0'}, 500);
                    $(this).stop().animate({'padding-bottom': '0'}, 500);
                });
        }
    });
}

module.exports = {
    init: function () {
        distributionmodules();
    }
};
